import { Input } from 'components';
import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';

import './styles.scss';

// Imagine you have a list of languages that you'd like to autosuggest.
const languages = (value: any) => {
  const domains = [
    'yahoo.com.br',
    'yahoo.com',
    'hotmail.com',
    'gmail.com',
    'aol.com',
    'live.com',
    'msn.com',
    'facebook.com',
    'outlook.com',
    'icloud.com',
  ];

  return domains.map((domain) => {
    const prefix = String(value).split('@').shift();

    return `${prefix}@${domain}`;
  });
};

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value: any) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return value.indexOf('@') === -1 ? [] : languages(value).filter((lang) => lang.toLowerCase().slice(0, inputLength) === inputValue);
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = (suggestion: any) => suggestion;

// Use your imagination to render suggestions.
const renderSuggestion = (suggestion: any) => <div data-bunda>{suggestion}</div>;

interface InputSuggestProps extends React.InputHTMLAttributes<HTMLInputElement> {
  handleOnChange: (value: string) => void;
  handleOnBlur?: (value: string) => void;
  // inputRef: React.RefObject<HTMLInputElement>;
}

const InputSuggest = ({
  handleOnChange,
  handleOnBlur,
  value,
  onBlur,
  // inputRef,
  ...props
}: InputSuggestProps) => {
  // const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState<any>([]);

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  const onSuggestionsFetchRequested = ({ value }: any) => {
    setSuggestions(getSuggestions(value));
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const storeInputReference = (autosuggest: any) => {
    if (autosuggest !== null) {
      return autosuggest.input;
    }
  };

  // Autosuggest will pass through all these props to the input.
  // const inputProps = ;

  const renderInputComponent = (inputProps: any) => {
    let currentProps = inputProps;

    if ((props as any)['data-error']) {
      //@ts-ignore
      currentProps['data-error'] = true;
    }

    return <Input {...currentProps} />;
  };

  // Finally, render it!
  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={{
        value: String(value),
        onChange: (_, { newValue }) => {
          if (handleOnChange) handleOnChange(newValue);
        },
        onBlur: (event) => {
          if (handleOnBlur) handleOnBlur((event.target as HTMLInputElement).value);
        },
      }}
      renderInputComponent={renderInputComponent}
      // renderInputComponent={renderInputComponent}
      ref={storeInputReference}
    />
  );
};

export default InputSuggest;
